import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';
import { map, mergeMap } from 'rxjs/operators';
import { Store } from '@ngrx/store';

import { AppState } from '../../store';
import { selectAccountId } from '../../account/store/account.selectors';
import { Member, STANDARD_ROLES } from '../members.models';
import { QueryParams } from '../../models/http.models';
import { environment } from '../../../environments/environment';
import { ListParams } from '../../common/helper/query-params-generic-list.helper';

@Injectable({
  providedIn: 'root',
})
export class MembersResource {
  private apiRoot: string = `${environment.API_URL}`;

  constructor(
    private http: HttpClient,
    private store: Store<AppState>,
  ) {}

  get(member_id: number, params?: ListParams): Observable<Member> {
    return this.store.pipe(
      selectAccountId,
      mergeMap((account_id) =>
        this.http.get<Member>(`${this.apiRoot}/${account_id}/api/members/${member_id}`, {
          params: params as QueryParams,
        }),
      ),
    );
  }

  save(body: Partial<Member>, params?: ListParams): Observable<Member> {
    return this.store.pipe(
      selectAccountId,
      mergeMap((account_id) =>
        this.http.post<Member>(`${this.apiRoot}/${account_id}/api/members`, body, { params: params as QueryParams }),
      ),
    );
  }

  update(member_id: number, body: Partial<Member>, params?: ListParams): Observable<Member> {
    return this.store.pipe(
      selectAccountId,
      mergeMap((account_id) =>
        this.http.put<Member>(`${this.apiRoot}/${account_id}/api/members/${member_id}`, body, {
          params: params as QueryParams,
        }),
      ),
    );
  }

  remove(member_id: number, params?: ListParams): Observable<any> {
    return this.store.pipe(
      selectAccountId,
      mergeMap((account_id) =>
        this.http.delete<Member>(`${this.apiRoot}/${account_id}/api/members/${member_id}`, {
          params: params as QueryParams,
        }),
      ),
    );
  }

  query(params?: ListParams): Observable<Member[]> {
    return this.store.pipe(
      selectAccountId,
      mergeMap((account_id) =>
        this.http.get<Member[]>(`${this.apiRoot}/${account_id}/api/members`, { params: params as QueryParams }),
      ),
    );
  }

  search(params?: ListParams): Observable<Member[]> {
    return this.store.pipe(
      selectAccountId,
      mergeMap((account_id) =>
        this.http.get<Member[]>(`${this.apiRoot}/${account_id}/api/members/search`, { params: params as QueryParams }),
      ),
    );
  }
}
